import $i18n from '@/locale-view/i18n';
import { ValidatorPosition } from '@/common/manager/position/validator-position';
import { symbolMap, timeMillisecondMap, timeUnitList, timeUnitMap, } from '@/common/util/expr-const';
import dayjs from 'dayjs';
export const compareList = [
    {
        label: $i18n.get({ id: 'CannotExceed', dm: '不能超过' }),
        value: '<=',
    },
    {
        label: $i18n.get({ id: 'CannotBeLess', dm: '不能小于' }),
        value: '>=',
    },
];
const compareMap = {};
compareList.forEach((item) => {
    const { label, value } = item || {};
    compareMap[value] = label;
});
export const config = {
    value: 'dateInterval',
    position: [
        ValidatorPosition.filter,
        ValidatorPosition.form,
        ValidatorPosition.formDialog,
    ],
    showInFilterComponentList: ['RangePicker'],
    action: (config) => {
        const { position, validateItemConfig } = config || {};
        const { name, message, options } = validateItemConfig || {};
        const { compare, num, unit } = options || {};
        if ([ValidatorPosition.filter].includes(position)) {
            if (name && unit && compare && typeof num === 'number') {
                return {
                    validator: (rule, value, cb) => {
                        if (Array.isArray(value)) {
                            const start = value[0];
                            const end = value[1];
                            if (start && end) {
                                const isDay = timeUnitList.find((item) => item.value === unit);
                                const func = symbolMap[compare];
                                if (isDay) {
                                    const startDay = dayjs(start).startOf(unit);
                                    const endDay = dayjs(end).startOf(unit);
                                    const diff = endDay.diff(startDay, unit);
                                    if (typeof func === 'function') {
                                        const result = func(diff, num);
                                        if (typeof result === 'boolean') {
                                            if (result !== true) {
                                                cb(message ||
                                                    `${$i18n.get({
                                                        id: 'IntervalTime',
                                                        dm: '间隔时间',
                                                    })} ${compareMap[compare] || compare} ${num} ${timeUnitMap[unit] || unit}`);
                                                return;
                                            }
                                        }
                                    }
                                }
                                else {
                                    const startTime = dayjs(start).valueOf();
                                    const endTime = dayjs(end).valueOf();
                                    if (typeof func === 'function') {
                                        const diff = endTime - startTime;
                                        const result = func(diff, num * timeMillisecondMap[unit]);
                                        if (typeof result === 'boolean') {
                                            if (result !== true) {
                                                cb(message ||
                                                    `${$i18n.get({
                                                        id: 'IntervalTime',
                                                        dm: '间隔时间',
                                                    })} ${compareMap[compare] || compare} ${num} ${timeUnitMap[unit] || unit}`);
                                                return;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        cb();
                    },
                };
            }
        }
        else if ([ValidatorPosition.form, ValidatorPosition.formDialog].includes(position)) {
            if (name && unit && compare && typeof num === 'number') {
                return {
                    validator: (value) => {
                        if (Array.isArray(value)) {
                            const start = value[0];
                            const end = value[1];
                            if (start && end) {
                                const isDay = timeUnitList.find((item) => item.value === unit);
                                const func = symbolMap[compare];
                                if (isDay) {
                                    const startDay = dayjs(start).startOf(unit);
                                    const endDay = dayjs(end).startOf(unit);
                                    const diff = endDay.diff(startDay, unit);
                                    if (typeof func === 'function') {
                                        const result = func(diff, num);
                                        if (typeof result === 'boolean') {
                                            if (result !== true) {
                                                return (message ||
                                                    `${$i18n.get({
                                                        id: 'IntervalTime',
                                                        dm: '间隔时间',
                                                    })} ${compareMap[compare] || compare} ${num} ${timeUnitMap[unit] || unit}`);
                                            }
                                        }
                                    }
                                }
                                else {
                                    const startTime = dayjs(start).valueOf();
                                    const endTime = dayjs(end).valueOf();
                                    if (typeof func === 'function') {
                                        const diff = endTime - startTime;
                                        const result = func(diff, num * timeMillisecondMap[unit]);
                                        if (typeof result === 'boolean') {
                                            if (result !== true) {
                                                return (message ||
                                                    `${$i18n.get({
                                                        id: 'IntervalTime',
                                                        dm: '间隔时间',
                                                    })} ${compareMap[compare] || compare} ${num} ${timeUnitMap[unit] || unit}`);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                };
            }
        }
    },
};
